import { useMemo } from 'react';
import { useMeContext } from 'modules/me';

export type FeatureFlagKeys =
  | 'isMenuFeedbackEnabled'
  | 'isTiWebNotesInsightsPageEnabled'
  | 'isTiAutoAcceptUserSettingsEnabled'
  | 'isShowCollapseAll'
  | 'isTIWebGroupViewEnabled'
  | 'isTiwDurationIndependentStartEndTime'
  | 'isSessionV2Enabled'
  | 'isTiwSupervisorInsightsEnabled'
  | 'isLabelLevelAcceptedByEnabled'
  | 'isTimeSignalFederatedSuggestionsEnabled'
  | 'isBrowserWhitelistEnabled'
  | 'isLoadingIconForCollectorsEnabled'
  | 'isTiwVpatEnabled'
  | 'isTiwScreenReaderEnabled'
  | 'isCollectorErrorCategoryEnabled';

export type FeatureFlagType = boolean | string | number;
export function useFeatureFlag<FeatureFlagType = boolean>(
  key: FeatureFlagKeys,
  defaultValue?: FeatureFlagType
): FeatureFlagType {
  const me = useMeContext();
  return useMemo(() => {
    return (me?.featureFlags[key] ?? defaultValue) as FeatureFlagType;
  }, [defaultValue, key, me]);
}

export const useFeatureFlags = (
  keys: FeatureFlagKeys[],
  defaultValue = false
): Record<FeatureFlagKeys, boolean> => {
  const me = useMeContext();
  return useMemo(
    () =>
      keys.reduce((acc, key) => {
        const resolvedFlag = me?.featureFlags[key];

        return {
          ...acc,
          [key]: resolvedFlag ?? defaultValue
        };
      }, {} as Record<FeatureFlagKeys, boolean>),
    [keys, me, defaultValue]
  );
};
